import {
  useInfiniteQuery,
  type InfiniteData,
  type UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { getBillRateShifts } from 'api/billRates/getBillRateShifts'
import { billRatesKeys } from './keys'

type UseBillRateShiftsQueryData = Awaited<ReturnType<typeof getBillRateShifts>>
type UseBillRateShiftsQueryKey = ReturnType<typeof billRatesKeys.shifts>
type UseBillRateShiftsQueryPageParam = number

type UseBillRateShiftsQueryOptions = Partial<
  UseInfiniteQueryOptions<
    UseBillRateShiftsQueryData,
    Error,
    InfiniteData<UseBillRateShiftsQueryData, UseBillRateShiftsQueryPageParam>,
    UseBillRateShiftsQueryData,
    UseBillRateShiftsQueryKey,
    UseBillRateShiftsQueryPageParam
  >
>

export function getBillRateShiftsNextPageParam(
  lastPage: UseBillRateShiftsQueryData
): number | undefined {
  const nextPage = lastPage.currentPage + 1
  if (nextPage < lastPage.totalPages) {
    return nextPage
  }
  return undefined
}

export function useBillRateShiftsQuery(
  request: { billRateId: number; pageSize: number },
  options: UseBillRateShiftsQueryOptions = {}
) {
  return useInfiniteQuery<
    UseBillRateShiftsQueryData,
    Error,
    InfiniteData<UseBillRateShiftsQueryData, UseBillRateShiftsQueryPageParam>,
    UseBillRateShiftsQueryKey,
    UseBillRateShiftsQueryPageParam
  >({
    ...options,
    queryKey: billRatesKeys.shifts(request),
    initialPageParam: 0,
    queryFn: ({ pageParam }) =>
      getBillRateShifts({
        billRateId: request.billRateId,
        page: pageParam,
        pageSize: request.pageSize,
      }),
    getNextPageParam: getBillRateShiftsNextPageParam,
  })
}
